'use strict';

var Json_decode = require("@glennsl/bs-json/lib/js/src/Json_decode.js");

function armorStages(json) {
  return {
          weakStage: Json_decode.field("WeakStage", Json_decode.$$int, json),
          middleStage: Json_decode.field("MiddleStage", Json_decode.$$int, json),
          strongStage: Json_decode.field("StrongStage", Json_decode.$$int, json)
        };
}

function settings(json) {
  return {
          bannedEquipment: Json_decode.field("BannedEquipment", (function (param) {
                  return Json_decode.array(Json_decode.$$int, param);
                }), json),
          damageDisableSeconds: Json_decode.field("DamageDisableSeconds", Json_decode.$$int, json),
          banTeleportItems: Json_decode.field("BanTeleportItems", Json_decode.bool, json),
          banPrefixedArmor: Json_decode.field("BanPrefixedArmor", Json_decode.bool, json),
          potionHealAmount: Json_decode.field("PotionHealAmt", Json_decode.$$int, json),
          potionHealCooldown: Json_decode.field("PotionHealCooldown", Json_decode.$$int, json),
          preventImpossibleEquipment: Json_decode.field("PreventImpossibleEquipment", Json_decode.bool, json),
          beetleArmorStages: Json_decode.field("BeetleArmorStages", armorStages, json),
          solarArmorStages: Json_decode.field("SolarArmorStages", armorStages, json),
          forceMaxHealth: Json_decode.field("ForceMaxHealth", Json_decode.bool, json),
          neverRain: Json_decode.field("NeverRain", Json_decode.bool, json),
          allowHookOfDissonance: Json_decode.field("AllowHookOfDissonance", Json_decode.bool, json),
          correctPositionDesync: Json_decode.field("CorrectPositionDesync", Json_decode.bool, json),
          correctionMinDistance: Json_decode.field("CorrectionMinDistance", Json_decode.$$int, json),
          defenseMultiplier: Json_decode.field("DefenseMultiplier", Json_decode.$$int, json),
          damageVariation: Json_decode.field("DamageVariation", Json_decode.$$int, json),
          time: Json_decode.field("Time", Json_decode.$$int, json)
        };
}

var Decode = {
  armorStages: armorStages,
  settings: settings
};

exports.Decode = Decode;
/* No side effect */
